import { render, staticRenderFns } from "./page-block.vue?vue&type=template&id=71d72f76"
import script from "./page-block.vue?vue&type=script&lang=js"
export * from "./page-block.vue?vue&type=script&lang=js"
import style0 from "./page-block.vue?vue&type=style&index=0&id=71d72f76&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71d72f76')) {
      api.createRecord('71d72f76', component.options)
    } else {
      api.reload('71d72f76', component.options)
    }
    module.hot.accept("./page-block.vue?vue&type=template&id=71d72f76", function () {
      api.rerender('71d72f76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/components/page-block.vue"
export default component.exports